import AvgPay from "./AvgPay";
import CalculateMonthlyGrossPay from "./CalculateMonthlyGrossPay";

interface payRecords {
    is_Duplicate: number;
    Pay_frequency: any;
    Gross_Pay: number | string | null;
    End_date?: any;
    Start_date?: any;
  }

interface EmployerSource {
    "files":payRecords[];
}
export const TotalGrossPay =(EmployerSources:EmployerSource[])=>{
    const totalGrossPay = EmployerSources.reduce((acc, curr) => {
        const total= acc + AvgPay(CalculateMonthlyGrossPay(curr.files),curr.files);
        return total;
    }, 0)
    return totalGrossPay;
}